'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lightReactBurgerMenu = require('light-react-burger-menu');

var _reactAnimateHeight = require('react-animate-height');

var _reactAnimateHeight2 = _interopRequireDefault(_reactAnimateHeight);

var _bodyScrollLock = require('body-scroll-lock');

var _fabfitfunSharedGlobal = require('@bit/fabfitfun.shared.global.button');

var _fabfitfunSharedGlobal2 = _interopRequireDefault(_fabfitfunSharedGlobal);

var _BurgerMenuStyles = require('./BurgerMenuStyles');

var _BurgerMenu = require('./BurgerMenu.utils');

var _BurgerMenu2 = _interopRequireDefault(_BurgerMenu);

var _helperUtils = require('../helperUtils');

var _helperUtils2 = _interopRequireDefault(_helperUtils);

require('./BurgerMenu.css');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var BurgerMenu = function (_Component) {
  _inherits(BurgerMenu, _Component);

  function BurgerMenu() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, BurgerMenu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BurgerMenu.__proto__ || Object.getPrototypeOf(BurgerMenu)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      menuItemDisplays: {},
      menuIsOpen: false
    }, _this.setMenuItemDisplaysState = function () {
      var menuItemDisplays = _BurgerMenu2.default.buildMenuItemDisplays(_this.props);

      _this.setState({
        menuItemDisplays: menuItemDisplays
      });
    }, _this.closeMenu = function () {
      _this.setState({
        menuIsOpen: false
      });
    }, _this.toggleExpand = function (id) {
      var updateState = function updateState(state) {
        var nextMenuItemState = _defineProperty({}, id, !state.menuItemDisplays[id]);

        var menuItemDisplays = Object.assign({}, state.menuItemDisplays, nextMenuItemState);
        return {
          menuItemDisplays: menuItemDisplays,
          menuIsOpen: true
        };
      };

      _this.setState(updateState);
    }, _this.toggleExpandCategory = function (category, hasChildren) {
      _this.toggleExpand(category.slug);

      _this.props.callbacks.handleClickCategory(category);

      if (!hasChildren) _this.closeMenu();
    }, _this.onMenuStateChange = function (menuState) {
      var isOpen = menuState.isOpen;

      if (isOpen) {
        (0, _bodyScrollLock.disableBodyScroll)(document.querySelector('.bm-menu'));
      } else {
        (0, _bodyScrollLock.clearAllBodyScrollLocks)();
      }
    }, _this.goToRoute = function (_ref2) {
      var route = _ref2.route,
          subdomain = _ref2.subdomain,
          inApp = _ref2.inApp;

      if (!route) {
        return;
      }

      var history = _this.props.history;

      if (inApp && history) {
        history.push(route);
        return;
      }

      var domainParts = window.location.hostname.split('.');
      var length = domainParts.length;
      var sub = subdomain ? subdomain + '.' : '';
      var domain = '' + sub + domainParts[length - 2] + '.' + domainParts[length - 1];
      var url = 'https://' + domain + route;
      window.location.href = url;
    }, _this.buildCategoriesTree = function (categories, routeId) {
      var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      var _this2 = _this,
          toggleExpandCategory = _this2.toggleExpandCategory,
          buildCategoriesTree = _this2.buildCategoriesTree;
      var getSubMenuHeight = _BurgerMenu2.default.getSubMenuHeight,
          getExpandSymbol = _BurgerMenu2.default.getExpandSymbol;
      var selectedCategorySlug = _this.props.selectedCategorySlug;
      if (categories.length === 0 || !Array.isArray(categories)) return;
      return _react2.default.createElement(_reactAnimateHeight2.default, {
        duration: 500,
        height: getSubMenuHeight(routeId, _this.state)
      }, categories.reduce(function (categoryList, category) {
        return [].concat(_toConsumableArray(categoryList), [_react2.default.createElement('div', {
          className: 'header-sub-menu',
          key: category.slug
        }, _react2.default.createElement('div', {
          className: 'header-sub-menu-item d-flex flex-jsb flex-aic ' + (category.slug === selectedCategorySlug ? 'selected-cat' : ''),
          style: {
            padding: '13px ' + level * 15 + 'px'
          },
          onClick: function onClick() {
            return toggleExpandCategory(category, category.children.length > 0);
          }
        }, category.name, category.children.length > 0 && _react2.default.createElement('div', {
          className: 'fs-24 fw-bold header-sub-menu-item-expand'
        }, getExpandSymbol(category.slug, _this.state))), buildCategoriesTree(category.children, category.slug, level + 1))]);
      }, []));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(BurgerMenu, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setMenuItemDisplaysState();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          children = _props.children,
          routes = _props.routes,
          categories = _props.categories,
          logoURL = _props.logoURL,
          userInfo = _props.userInfo;
      var _routes$buttonRoutes = routes.buttonRoutes,
          buttonRoutes = _routes$buttonRoutes === undefined ? [] : _routes$buttonRoutes;
      var toggleExpand = this.toggleExpand,
          buildCategoriesTree = this.buildCategoriesTree,
          state = this.state;
      var getSubMenuHeight = _BurgerMenu2.default.getSubMenuHeight,
          getExpandSymbol = _BurgerMenu2.default.getExpandSymbol;

      var _styles = (0, _BurgerMenuStyles.styles)(this.props),
          topBarClasses = _styles.topBarClasses,
          closeButtonClasses = _styles.closeButtonClasses;

      var createChild = function createChild(props) {
        return _react2.default.createElement(_react2.default.Fragment, {
          key: props.key
        }, props.component);
      };

      var preChildren = function preChildren(route) {
        return children.map(function (child) {
          if (child.placementIndex < 1 && child.id === route.id) {
            return createChild(child);
          }
        });
      };

      var postChildren = function postChildren(route) {
        return children.map(function (child) {
          if (child.placementIndex > 1 && child.id === route.id) {
            return createChild(child);
          }
        });
      };

      var showByUserPlan = function showByUserPlan(route, userInfo) {
        if (!route) {
          return false;
        }

        if (!route.hideByPlans) {
          return true;
        }

        if (!userInfo || !userInfo.planCode) {
          return false;
        }

        var isBlacklisted = route.hideByPlans.includes(userInfo.planCode);
        return !isBlacklisted;
      };

      var filteredMainRoutes = routes.mainRoutes.filter(function (route) {
        return showByUserPlan(route, userInfo);
      });
      return _react2.default.createElement(_lightReactBurgerMenu.slide, {
        onStateChange: this.onMenuStateChange,
        width: '100%',
        customCrossIcon: false,
        isOpen: this.state.menuIsOpen
      }, _react2.default.createElement('div', {
        className: topBarClasses
      }, _react2.default.createElement('img', {
        alt: 'FabFitFun',
        src: logoURL,
        onClick: function onClick() {
          window.location = _helperUtils2.default.getHomeUrl();
        }
      }), _react2.default.createElement('button', {
        className: closeButtonClasses,
        onClick: this.closeMenu
      }, _react2.default.createElement('i', {
        className: 'far fa-times'
      }))), filteredMainRoutes.map(function (route) {
        return _react2.default.createElement('div', {
          id: route.id,
          className: 'menu-item-container o-hidden',
          key: route.id
        }, _react2.default.createElement('div', {
          onClick: function onClick() {
            if (route.subRoutes) {
              toggleExpand(route.id);
            } else {
              _this3.goToRoute(route);
            }
          },
          className: 'd-flex flex-jsb top-menu-item flex-aic'
        }, _react2.default.createElement('div', null, route.label, route.live && _react2.default.createElement('span', {
          className: 'live-badge mar-4'
        }, 'LIVE')), (route.subRoutes || route.showCatgories) && _react2.default.createElement('div', {
          className: 'fs-24 fw-bold'
        }, getExpandSymbol(route.id, state))), route.showCatgories && buildCategoriesTree(categories, route.id), route.subRoutes && _react2.default.createElement(_reactAnimateHeight2.default, {
          duration: 500,
          height: getSubMenuHeight(route.id, state)
        }, children && preChildren(route), _react2.default.createElement('div', {
          className: 'header-sub-menu'
        }, route.subRoutes.map(function (subRoute) {
          return _react2.default.createElement('div', {
            className: 'header-sub-menu-item',
            key: subRoute.id,
            onClick: function onClick() {
              return _this3.goToRoute(subRoute);
            }
          }, subRoute.label);
        })), children && postChildren(route)));
      }), _react2.default.createElement('div', {
        className: 'ta-center'
      }, _react2.default.createElement('br', null), buttonRoutes.map(function (item) {
        return _react2.default.createElement(_fabfitfunSharedGlobal2.default, {
          type: _fabfitfunSharedGlobal.buttonTypes.PRIMARY.value,
          action: _fabfitfunSharedGlobal.actionTypes.CALL_TO_ACTION.value,
          label: item.label,
          id: item.id,
          alt: item.label,
          style: {
            borderRadius: 0,
            whiteSpace: 'nowrap'
          },
          onClick: function onClick() {
            _this3.goToRoute(item.route);
          }
        });
      })));
    }
  }]);

  return BurgerMenu;
}(_react.Component);

exports.default = BurgerMenu;